import UploadService from "@/services/upload";
import ErrorHandler from "../../../tools/errorHandler";

export default {
  async upload({ dispatch }, file) {
    try {
      return await UploadService.upload(file);
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  }
};
